import { Alert, Collapse, Typography } from '@mui/material';
import { useState } from 'react';
import { EmptyFunction } from './emptyFunction';
import BannerIcon from './BannerIcon';

export default function Banner({
  children,
  type,
  isDismissible = true,
  onDismissed = EmptyFunction,
  sx,
  isFloating = false,
}) {
  const [isDismissed, setIsDismissed] = useState(false);

  let bannerBody;
  const isSingleMessage = !children || typeof children === 'string';
  if (isSingleMessage) {
    bannerBody = (
      <Typography variant="body2" fontSize="16px">
        {children ?? 'Hér hefur eitthvað farið úrskeiðis'}
      </Typography>
    );
  } else {
    bannerBody = children;
  }

  const styles = {
    '&.MuiAlert-root': {
      alignItems: 'flex-start',
    },
    '& .MuiAlert-icon': {
      margin: 0,
      padding: 0,
      '& .MuiBox-root': {
        height: '30px',
        width: '30px',
      },
      '& .MuiSvgIcon-root': {
        fontSize: '1.4rem',
        color: 'white',
        margin: '5px',
      },
    },
    '& .MuiAlert-message': {
      padding: isSingleMessage ? 'auto' : 0,
      margin: isSingleMessage ? 'auto' : 0,
      marginLeft: '16px',
    },
    padding: '20px 20px',
    backgroundColor: 'white',
    color: 'basicblack.main',
    boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.25)',
    alignItems: 'flex-start',
    ...(isFloating
      ? {
          position: 'static',
          top: '9%',
          right: '6.4%',
          zIndex: 1000,
          marginBottom: '15px',
        }
      : {}),
    ...sx,
  };

  const timeout = 300;

  return (
    <Collapse in={!isDismissed} timeout={timeout} sx={{ width: '100%' }}>
      <Alert
        icon={<BannerIcon type={type} />}
        severity={'error'}
        variant="filled"
        sx={styles}
        onClose={
          isDismissible
            ? () => {
                setIsDismissed(true);
                setTimeout(onDismissed, timeout);
              }
            : undefined
        }
      >
        {bannerBody}
      </Alert>
    </Collapse>
  );
}
